import { render, staticRenderFns } from "./FollowingSettingsView.vue?vue&type=template&id=797b5c4a&"
import script from "./FollowingSettingsView.vue?vue&type=script&lang=ts&"
export * from "./FollowingSettingsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports